module.exports = __webpack_public_path__ + "img/dogs-2.80376e5c.jpg";